<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="应用名称" prop="applicationId">
        <el-select v-model="form.applicationId" placeholder="请选择">
          <el-option
            v-for="item in application"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="需求企业" prop="companyId">
        <el-select v-model="form.companyId" placeholder="请选择">
          <el-option
            v-for="item in company"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人姓名" prop="linkName">
        <el-input v-model="form.linkName" placeholder="请输入联系人姓名" v-trim/>
      </el-form-item>
      <el-form-item label="联系人电话" prop="linkPhone">
        <el-input v-model="form.linkPhone" maxlength="11" placeholder="请输入联系人电话" v-trim/>
      </el-form-item>
      <el-form-item label="需求说明" prop="details">
        <el-input type="textarea" :autosize="{ minRows: 12, maxRows: 6 }" v-model="form.details" placeholder="请输入需求说明" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaDemandRecordWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        status: '',
        remark: '',
        applicationId: '',
        companyId: '',
        linkName: '',
        linkPhone: '',
        details: ''
      },
      // 验证规则
      rules: {
      },
      application: [],
      company: []
    }
  },
  created () {
    this.config({
      api: '/business/demandRecord',
      'field.id': 'id'
    })
  }
}
</script>
